var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',{ref:"vueScroll",staticClass:"luttica-scroll-bar",style:(_vm.style),attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll,"handle-resize":_vm.handleResize}},[(_vm.id)?_c('div',{attrs:{"id":_vm.id}},[_vm._t("default")],2):_vm._t("default",null,{"id":_vm.id})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }